<template>
  <svg v-if="name === 'close'" :class="className" fill="none" viewBox="0 0 24 24">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.31539 6.89807C8.12013 6.7028 7.80354 6.7028 7.60828 6.89807C7.41302 7.09333 7.41302 7.40991 7.60828 7.60517L11.7104 11.7073L7.31557 16.1021C7.12031 16.2974 7.12031 16.614 7.31557 16.8092C7.51083 17.0045 7.82742 17.0045 8.02268 16.8092L12.4175 12.4144L16.8007 16.7976C16.9959 16.9928 17.3125 16.9928 17.5078 16.7976C17.703 16.6023 17.703 16.2857 17.5078 16.0905L13.1246 11.7073L17.2151 7.61684C17.4103 7.42157 17.4103 7.10499 17.2151 6.90973C17.0198 6.71447 16.7032 6.71447 16.508 6.90973L12.4175 11.0002L8.31539 6.89807Z"
      fill="currentColor"
    />
  </svg>
  <svg v-else-if="name === 'chevron-down'" :class="className" fill="none" viewBox="0 0 24 24">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.5889 9.64643C16.7842 9.84169 16.7842 10.1583 16.5889 10.3535L12.3463 14.5962C12.151 14.7914 11.8344 14.7914 11.6392 14.5962L7.39652 10.3535C7.20125 10.1583 7.20125 9.84169 7.39652 9.64643C7.59178 9.45117 7.90836 9.45117 8.10362 9.64643L11.9927 13.5355L15.8818 9.64643C16.0771 9.45117 16.3936 9.45117 16.5889 9.64643Z"
      fill="currentColor"
    />
  </svg>
  <svg v-else-if="name === 'chevron-left'" :class="className" fill="none" viewBox="0 0 24 24">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.0962 16.7175C13.901 16.9128 13.5844 16.9128 13.3891 16.7175L9.14648 12.4749C8.95122 12.2796 8.95122 11.963 9.14648 11.7678L13.3891 7.52512C13.5844 7.32986 13.901 7.32986 14.0962 7.52512C14.2915 7.72038 14.2915 8.03696 14.0962 8.23222L10.2071 12.1213L14.0962 16.0104C14.2915 16.2057 14.2915 16.5222 14.0962 16.7175Z"
      fill="currentColor"
    />
  </svg>
  <svg v-else-if="name === 'chevron-right'" :class="className" fill="none" viewBox="0 0 24 24">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.1464 7.52512C10.3417 7.32986 10.6583 7.32986 10.8536 7.52512L15.0962 11.7678C15.2915 11.963 15.2915 12.2796 15.0962 12.4749L10.8536 16.7175C10.6583 16.9128 10.3417 16.9128 10.1464 16.7175C9.95118 16.5222 9.95118 16.2057 10.1464 16.0104L14.0355 12.1213L10.1464 8.23223C9.95118 8.03697 9.95118 7.72039 10.1464 7.52512Z"
      fill="currentColor"
    />
  </svg>
  <svg v-else-if="name === 'chevron-up'" :class="className" fill="none" viewBox="0 0 24 24">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.39645 14.5962C7.20118 14.4009 7.20118 14.0843 7.39645 13.8891L11.6391 9.64644C11.8343 9.45117 12.1509 9.45117 12.3462 9.64644L16.5888 13.8891C16.7841 14.0843 16.7841 14.4009 16.5888 14.5962C16.3936 14.7914 16.077 14.7914 15.8817 14.5962L11.9926 10.7071L8.10355 14.5962C7.90829 14.7914 7.59171 14.7914 7.39645 14.5962Z"
      fill="currentColor"
    />
  </svg>
</template>

<script setup>
defineProps({
  className: {
    default: '',
    type: String,
  },
  name: {
    required: true,
    type: String,
  },
});
</script>
